import { render, staticRenderFns } from "./DynamicDetails.vue?vue&type=template&id=16c76895&scoped=true&"
import script from "./DynamicDetails.vue?vue&type=script&lang=js&"
export * from "./DynamicDetails.vue?vue&type=script&lang=js&"
import style0 from "./DynamicDetails.vue?vue&type=style&index=0&id=16c76895&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c76895",
  null
  
)

export default component.exports